import { http } from '@/repositories/http'
import store from '@/store/index'
import {
  JunshisanSettingRepository,
  JunshisanSettingRepositoryImpl
} from '@/repositories/fuzoku-meisai/junsoku/junshisanSettingRepository'
import {
  KyuyohiSettingRepository,
  KyuyohiSettingRepositoryImpl
} from '@/repositories/fuzoku-meisai/junsoku/kyuyohiSettingRepository'
import { HonbuhiRepository, HonbuhiRepositoryImpl } from '@/repositories/fuzoku-meisai/junsoku/honbuhiRepository'
import { TanpokenRepository, TanpokenRepositoryImpl } from '@/repositories/fuzoku-meisai/junsoku/tanpokenRepository'
import { HikiatekinRepository, HikiatekinRepositoryImpl } from '@/repositories/fuzoku-meisai/junsoku/hikiatekinRepository'
import { HojokinRepository, HojokinRepositoryImpl } from '@/repositories/fuzoku-meisai/junsoku/hojokinRepository'
import { KoteishisanRepository, KoteishisanRepositoryImpl } from '@/repositories/fuzoku-meisai/junsoku/koteishisanRepository'
import {
  KashitsukekinRepository,
  KashitsukekinRepositoryImpl
} from '@/repositories/fuzoku-meisai/junsoku/kashitsukekinRepository'
import { KariirekinRepository, KariirekinRepositoryImpl } from '@/repositories/fuzoku-meisai/junsoku/kariirekinRepository'

type Repositories = {
  junshisan: JunshisanSettingRepository;
  koteishisan: KoteishisanRepository;
  kashitsukekin: KashitsukekinRepository;
  kariirekin: KariirekinRepository;
  hikiatekin: HikiatekinRepository;
  hojokin: HojokinRepository;
  tanpoken: TanpokenRepository;
  kyuyohi: KyuyohiSettingRepository;
  honbuhi: HonbuhiRepository;
}

const fuzokuJunsokuUri = 'fuzoku/junsoku'

export const junsokuRepositories: Repositories = {
  junshisan: new JunshisanSettingRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  koteishisan: new KoteishisanRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  kashitsukekin: new KashitsukekinRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  kariirekin: new KariirekinRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  hikiatekin: new HikiatekinRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  hojokin: new HojokinRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  tanpoken: new TanpokenRepositoryImpl(http, fuzokuJunsokuUri),
  kyuyohi: new KyuyohiSettingRepositoryImpl(http, fuzokuJunsokuUri, store.state),
  honbuhi: new HonbuhiRepositoryImpl(http, fuzokuJunsokuUri, store.state)
}
